import Button from "components/common/buttons/buttons";
import Icon, { ICONS } from "components/common/Icons";
import DiscussSubscribeButton from "components/templates/common/Discuss/Detail/Button/SubscribeButton";
import { useDiscussIdContext } from "contexts/DiscussIdContext";
import { is } from "date-fns/locale";
import { track } from "lib/analytics/core/client";
import Image from "next/image";
import Link from "next/link";
import { useRouter } from "next/router";
import { TrackedLogo } from "lib/analytics/react/link";
import { useEffect, useState } from "react";
import { useRecoilState } from "recoil";
import { searchModalState } from "states/SearchModalState";

function DiscussDetailHeader({
  mutate,
  isMobile,
  DebateAlarmOnStatus,
  debateAlarmRegister,
}: {
  mutate?: any;
  isMobile: boolean;
  DebateAlarmOnStatus: any;
  debateAlarmRegister: any;
}) {
  const router = useRouter();
  const { discussId, slug } = useDiscussIdContext();
  const [searchModal, setSearchModal] = useRecoilState(searchModalState);

  const [showStickyHeader, setShowStickyHeader] = useState(false);
  const isOpinionDetailPage = router.pathname.startsWith(
    `/discuss/[slugId]/opinion`
  );
  const isDiscussDetail =
    router.pathname.includes("/discuss/") &&
    !router.pathname.includes("opinion");
  useEffect(() => {
    if (!isMobile) return;

    const subscribeButton = document.getElementById("discuss-top-thumb");
    if (!subscribeButton) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        // 요소가 화면에서 사라지면 sticky 헤더 표시
        setShowStickyHeader(!entry.isIntersecting);
      },
      {
        threshold: 0,
        rootMargin: "0px 0px 0px 0px",
      }
    );

    observer.observe(subscribeButton);

    return () => {
      observer.disconnect();
    };
  }, [isMobile]);
  if (isMobile) {
    return (
      <div
        className={`w-full h-[56px] py-3 pl-5 pr-[14px] flex justify-between items-center 
    ${
      isDiscussDetail
        ? showStickyHeader
          ? "fixed top-0 left-0 z-50 bg-white translate-y-0"
          : "fixed top-0 left-0 z-50 bg-white translate-y-[-100%] opacity-0 pointer-events-none"
        : ""
    }`}
        style={{
          transition: "all 0.5s ease-in-out",
        }}
      >
        <TrackedLogo
          href="/"
          asTrace={true}
          onClick={() => {
            window.dataLayer.push({
              event: "report-header-logo-button",
            });
            sessionStorage.removeItem(`main-scrollPosition`);
            sessionStorage.removeItem(`search-scrollPosition`);
          }}
        >
          <img
            width={30}
            height={30}
            src={`/images/header/headerLogo.svg`}
            alt="logo"
            className="cursor-pointer w-auto h-auto"
          />
        </TrackedLogo>
        {isOpinionDetailPage && (
          <Button
            type="text_gray"
            text="원문 보기"
            size="sm"
            clickHandler={() => {
              router.push(
                `/discuss/${slug ? `${slug}-${discussId}` : discussId}`
              );
            }}
            dataGtmId={`report-opinion-detail-view-origin-button`}
          />
        )}
        {/* {!isOpinionDetailPage && !DebateAlarmOnStatus?.isNewAgendaAlarmOn && (
          <DiscussSubscribeButton
            text="새 글 알림받기"
            isSubscribe={DebateAlarmOnStatus?.isNewAgendaAlarmOn}
            debateAlarmRegister={debateAlarmRegister}
            size="sm"
          />
        )} */}
        {!isOpinionDetailPage && (
          <div
            onClick={() => {
              track("search_open", {
                search_type: "unified", // 통합검색
                source: "report_detail",
              });
              setSearchModal((prev: any) => ({
                search: prev?.search,
                modalOpen: true,
              }));
            }}
            className="cursor-pointer p-[6px]"
            data-gtm-id="report-header-search-button"
          >
            <Icon name={ICONS.SEARCH} height={30} width={30} fill="gray30" />
          </div>
        )}
      </div>
    );
  }

  return (
    <div
      className={`min-h-[56px] py-3 relative w-full  flex justify-end pr-2 items-center `}
    >
      <div
        className="back absolute top-[50%] left-[4px] translate-y-[-50%] p-3 cursor-pointer"
        onClick={() => {
          if (mutate) {
            mutate();
          }
          router.back();
        }}
      >
        <Image
          src={"/images/icons/back.svg"}
          alt="arrow"
          width={24}
          height={24}
        />
      </div>
      {isOpinionDetailPage && (
        <Button
          type="text_gray"
          text="원문 보기"
          size="sm"
          clickHandler={() => {
            router.push(
              `/discuss/${slug ? `${slug}-${discussId}` : discussId}`
            );
          }}
          dataGtmId={`report-opinion-detail-view-origin-button`}
        />
      )}
      {!isOpinionDetailPage && !DebateAlarmOnStatus?.isNewAgendaAlarmOn && (
        <DiscussSubscribeButton
          text="새 글 알림받기"
          isSubscribe={DebateAlarmOnStatus?.isNewAgendaAlarmOn}
          debateAlarmRegister={debateAlarmRegister}
          size="sm"
        />
      )}
      {/* <div className="cursor-pointer absolute right-[12px] top-[50%] translate-y-[-50%] justify-center items-center gap-1 inline-flex">
        <Button
          clickHandler={() => {
            // editHandler();
            router.push("/discuss/list");
            if (mutate) {
              mutate();
            }
          }}
          text={"토론 전체보기"}
          size="md"
          type="text_gray"
          btnClass="!bg-transparent "
        />
      </div> */}
    </div>
  );
}

export default DiscussDetailHeader;
